export function getErrorMessage(error: any): string | null {
  if (typeof error === 'string') {
    return error
  }
  if (error && typeof error.message === 'string') {
    return error.message
  }
  return null
}
